import React from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import PanelLayout from "../components/PanelLayout";

class InputItemsPanel extends React.Component {
    render() {
        return (
            <PanelLayout/>
        );
    }
}

function mapStateToProps(state) {
    return {
        node: state.modalInfo.node,
    }
}


export default connect(mapStateToProps, {hideModal})(InputItemsPanel);